module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    attrs: {
      "id": "my-questions"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "titleClass": "blueTitle largeTitle",
      "title": "My questions",
      "subTitle": "Your recent questions"
    }
  }), _vm._v(" "), _c('mu-list', [(_vm.isLoading) ? _c('div', _vm._l((_vm.dummyLoaders), function(item, index) {
    return _c('mu-list-item', {
      key: 'dl-' + index,
      attrs: {
        "title": item.display_name
      }
    }, [_c('mu-linear-progress', {
      staticStyle: {
        "width": "50%",
        "height": "12px",
        "background": "rgb(214, 214, 214)",
        "margin-bottom": "8px"
      },
      attrs: {
        "slot": "describe",
        "color": "#d9d9d9"
      },
      slot: "describe"
    }), _vm._v(" "), _c('mu-linear-progress', {
      staticStyle: {
        "width": "16%",
        "height": "12px",
        "background": "rgb(214, 214, 214)",
        "margin-bottom": "8px"
      },
      attrs: {
        "slot": "describe",
        "color": "#d9d9d9"
      },
      slot: "describe"
    })], 1)
  }), 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', [_c('div', [_c('mu-content-block', [_vm._v("\n          No questions added yet\n        ")])], 1), _vm._v(" "), _vm._m(0)], 2) : _vm._e()]), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "left"
    }
  }, [(_vm.data.length > 0) ? _c('mu-raised-button', {
    attrs: {
      "label": "See all",
      "fullWidth": ""
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._l((_vm.data), function(item, index) {
    return _c('mu-list-item', {
      key: 'q-' + index,
      attrs: {
        "title": item.question
      }
    }, [_vm._o(_c('mu-avatar', {
      attrs: {
        "slot": "left",
        "src": item.profile_large,
        "color": "white",
        "backgroundColor": "#E9E9E8"
      },
      slot: "left"
    }), 0, 'q-' + index)], 1)
  })
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fcbd4c2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Questions/MyQuestions/MyQuestions.vue
// module id = 3168
// module chunks = 1